/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Location } from './Location';
import type { User } from './User';
export type SalesOrderItem = {
    /**
     * Unique sales order item identifier
     */
    id: number;
    /**
     * Original price of the product
     */
    originalPrice: number;
    /**
     * Markup type applied before discount
     */
    markupType: SalesOrderItem.markupType;
    /**
     * Markup value
     */
    markupValue?: number;
    /**
     * Price after markup and before discount
     */
    adjustedPrice: number;
    /**
     * Discount type
     */
    discountType: SalesOrderItem.discountType;
    /**
     * Discount value
     */
    discountValue?: number;
    /**
     * Final price after discount
     */
    finalPrice: number;
    /**
     * Item discount applied
     */
    itemDiscountApplied: boolean;
    /**
     * Whether this piece was already at the selling branch (LOCAL) or needs to be pulled from another location (REMOTE)
     */
    fulfillmentType: SalesOrderItem.fulfillmentType;
    /**
     * Location the piece is being pulled from (REMOTE items only)
     */
    sourceLocation?: Location | null;
    /**
     * Whether this piece was handed to the customer (independent of payment/logistics)
     */
    isDelivered: boolean;
    /**
     * When the piece was handed to the customer
     */
    deliveredAt?: string | null;
    /**
     * User who marked the piece as delivered
     */
    deliveredBy?: User | null;
};
export namespace SalesOrderItem {
    /**
     * Markup type applied before discount
     */
    export enum markupType {
        PERCENTAGE = 'PERCENTAGE',
        AMOUNT = 'AMOUNT',
        NONE = 'NONE',
    }
    /**
     * Discount type
     */
    export enum discountType {
        PERCENTAGE = 'PERCENTAGE',
        AMOUNT = 'AMOUNT',
        NONE = 'NONE',
    }
    /**
     * Whether this piece was already at the selling branch (LOCAL) or needs to be pulled from another location (REMOTE)
     */
    export enum fulfillmentType {
        LOCAL = 'LOCAL',
        REMOTE = 'REMOTE',
    }
}

